import { Tag, TagVariant } from '@deliveryhero/pd-cookbook/components/Tag';

import { Allowance, AllowanceBudgetType } from 'services/api';

import { Column } from '../TableList/SortableHeader';
import { SendAllowanceEmailButton } from './SendAllowanceEmailButton';

export function allowanceColumns(
  currencyCode: string,
  handleSendAllowanceEmail: (allowance_id: Allowance['id']) => void,
  enableSendAllowance: boolean
): Column<Allowance>[] {
  const renderTag = (variant: TagVariant, label: string) => {
    return <Tag id={variant} label={label} variant={variant} />;
  };

  const columns: Column<Allowance>[] = [
    {
      id: 'name',
      options: { disablePadding: false },
      label: 'Name',
      format: (allowance: Allowance) => <div>{allowance.name}</div>
    },
    {
      id: 'company_departments',
      options: { disablePadding: false },
      label: 'Employees / Departments',
      format: (allowance: Allowance) => (
        <div>
          {(allowance.company_departments?.length
            ? allowance.company_departments.map((d) => d.name)
            : allowance.applicable_users_details?.length
            ? allowance.applicable_users_details.map(
                (u) => `${u.first_name} ${u.last_name}`
              )
            : []
          ).join(', ')}
        </div>
      )
    },
    {
      id: 'applicable_weekdays',
      options: { disablePadding: false },
      label: 'Days / Dates',
      format: (allowance: Allowance) => {
        let allowance_date_from = new Date(allowance.allowance_date_from);
        allowance_date_from = new Date(
          allowance_date_from.getTime() +
            allowance_date_from.getTimezoneOffset() * 60000
        );

        let allowance_date_to =
          allowance.allowance_date_to && new Date(allowance.allowance_date_to);
        allowance_date_to =
          allowance_date_to &&
          new Date(
            allowance_date_to.getTime() +
              allowance_date_to.getTimezoneOffset() * 60000
          );

        return (
          <>
            <div>{allowance.applicable_weekdays.join(', ')}</div>
            {allowance.budget_type.toLowerCase() ===
              AllowanceBudgetType.Custom.toLowerCase() && (
              <span
                style={{
                  fontSize: '14px',
                  lineHeight: '21px',
                  color: '#767676'
                }}
              >
                {`${new Date(allowance_date_from).toLocaleDateString(
                  'en-GB'
                )} - ${
                  allowance_date_to
                    ? new Date(allowance_date_to).toLocaleDateString('en-GB')
                    : 'No end date'
                }`}
              </span>
            )}
          </>
        );
      }
    },
    {
      id: 'budget',
      options: { disablePadding: false },
      label: `Amount (${currencyCode})`,
      format: (allowance) => {
        return (
          <>
            <div>{allowance.budget}</div>
            <span
              style={{
                fontSize: '14px',
                lineHeight: '21px',
                color: '#767676',
                textTransform: 'capitalize'
              }}
            >
              {allowance.budget_type.toLowerCase() === 'custom'
                ? 'One time'
                : allowance.budget_type}
            </span>
          </>
        );
      }
    },
    {
      id: 'state',
      options: { disablePadding: false },
      label: 'Status',
      format: (allowance) => {
        return allowance.state === 'active'
          ? renderTag(TagVariant.SUCCESS, allowance.state)
          : allowance.state === 'inactive'
          ? renderTag(TagVariant.INACTIVE, allowance.state)
          : renderTag(TagVariant.INFORMATION, allowance.state);
      }
    }
  ];

  if (enableSendAllowance)
    columns.push({
      id: 'welcome_email_sent_timestamp',
      label: '',
      format: (allowance: Allowance) => {
        return allowance.state === 'active' ? (
          <SendAllowanceEmailButton
            welcome_email_sent_timestamp={
              allowance.welcome_email_sent_timestamp
            }
            id={allowance.id}
            handleSendAllowanceEmail={handleSendAllowanceEmail}
          />
        ) : (
          <></>
        );
      }
    });

  return columns;
}
